export default __webpack_public_path__ + "static/media/combined-3rd-party.cd122bbb.png";